import { render, staticRenderFns } from "./RpaUltra.vue?vue&type=template&id=4080951d&scoped=true&"
import script from "./RpaUltra.vue?vue&type=script&lang=js&"
export * from "./RpaUltra.vue?vue&type=script&lang=js&"
import style0 from "./RpaUltra.vue?vue&type=style&index=0&id=4080951d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080951d",
  null
  
)

export default component.exports